<style scoped>
.echarts {
  width: 100%;
  height: 100%;
}
</style>

<template>
  <div>
    <div class="echarts" :id="id" ref="echarts"></div>
  </div>
</template>

<script>
export default {
  name: "echarts",
  props: {
    score: Number,
    id: String
  },
  data() {
    return {};
  },
  watch: {
    score() {
      this.createEcharts();
    }
  },
  mounted() {
    this.createEcharts();
  },
  methods: {
    createEcharts() {
      let $echartsDOM = document.getElementById(this.id);
      let myEcharts = this.$echarts.init($echartsDOM);
      let option = {
        series: [
          {
            name: "业务指标",
            type: "gauge",
            center : ['center', '70%'],
            radius: "100%",
            startAngle: "180",
            endAngle: "0",
            splitNumber:3,
            splitLine: {
              show: true,
              length: 10,
              lineStyle: {
                color: "#fff"
              }
            },
            axisLabel: {
              show: false
            },
            axisTick: {
              show: false
            },
            pointer: {
              show:false,
              length: "40%"
            },
            detail: {
              formatter: "{score|{value}}",
              // offsetCenter: [0, "-55%"],
              offsetCenter: [0, "-25%"],
              rich: {
                score: {
                  fontSize: 48,
                  fontWeight:'bold'
                }
              }
            },
            axisLine: {
              show: false,
              lineStyle: {
                width: 10,
                shadowBlur: 0,
                color: [[0.33, "#4ACAA8"], [0.67, "#F5A623"], [1, "#4169E1"]]
              }
            },
            data: [
              {
                value: this.score
              }
            ]
          }
        ]
      };
      myEcharts.setOption(option);
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/echarts_gauge/index.vue